<template>
  <router-view />
</template>
<script>
export default {
  name: 'BlankLayout',
};
</script>



// WEBPACK FOOTER //
// src/layouts/Blank.vue